<template>
  <BaseLogin>
    <template v-slot:logoCenter>
      <div class="middle-box text-center">
        <img style="width: 500px" src="../../../public/img/sgo-logo-azul.png" alt="logo">
        <p class="h4 mt-2 font-weight-bold" style="color: #0b2545;">Sistema de Gestão de Obras</p>
      </div>
    </template>

    <template v-slot:formLogin>
      <form @submit.prevent="mudarSenha">
        <div class="text-center mb-4">
          <p class="h6 font-weight-bold text-danger">Atenção: Este é o seu primeiro acesso. Você precisa cadastrar uma nova senha.</p>
        </div>
        <div class="form-group">
          <InputGroup size="small">
            <InputGroupAddon>
              <i class="pi pi-lock"></i>
            </InputGroupAddon>
            <FloatLabel variant="on">
              <Password inputId="senhaAtual" v-model="form.senha_atual" :feedback="false" toggleMask size="small"
                        fluid style="width: 100%"
                        :inputProps="{ autocomplete: 'current-password' }"
                        :invalid="campoVazio.includes('senha_atual')"/>
              <label for="senhaAtual"><strong>Senha Atual: </strong></label>
            </FloatLabel>
          </InputGroup>
        </div>
        
        <div class="form-group">
          <InputGroup size="small">
            <InputGroupAddon>
              <i class="pi pi-key"></i>
            </InputGroupAddon>
            <FloatLabel variant="on">
              <Password inputId="novaSenha" v-model="form.nova_senha" :feedback="true" toggleMask size="small"
                        fluid style="width: 100%"
                        promptLabel="Digite uma senha" weakLabel="Muito simples" mediumLabel="Média complexidade" strongLabel="Senha forte"
                        :inputProps="{ autocomplete: 'new-password' }"
                        :invalid="campoVazio.includes('nova_senha')"/>
              <label for="novaSenha"><strong>Nova Senha: </strong></label>
            </FloatLabel>
          </InputGroup>
        </div>

        <div class="form-group">
          <InputGroup size="small">
            <InputGroupAddon>
              <i class="pi pi-key"></i>
            </InputGroupAddon>
            <FloatLabel variant="on">
              <Password inputId="confirmarSenha" v-model="form.confirmar_senha" :feedback="false" toggleMask size="small"
                        fluid style="width: 100%"
                        :inputProps="{ autocomplete: 'new-password' }"
                        :invalid="campoVazio.includes('confirmar_senha') || erroSenhasDiferentes"/>
              <label for="confirmarSenha"><strong>Confirmar Nova Senha: </strong></label>
            </FloatLabel>
          </InputGroup>
          <small v-if="erroSenhasDiferentes" class="p-error">As senhas não coincidem.</small>
        </div>

        <div class="form-group">
          <button type="submit" class="btn btn-primary font-bold w-50 p-3 m-b" :disabled="loading">
            <i class="pi pi-spin pi-spinner mr-2" v-if="loading"></i>
            Confirmar Nova Senha
          </button>
        </div>
        
        <div class="form-group text-center">
            <Button label="Voltar para o Login" icon="pi pi-arrow-left" severity="secondary" text @click="logout" />
        </div>
      </form>
    </template>
  </BaseLogin>
</template>

<script>
import { apiUrl } from "@/router/apiBackRoutes";
import BaseLogin from "@/components/base/BaseLogin.vue";

export default {
  name: 'PrimeiroAcesso',
  components: {
    BaseLogin
  },
  data() {
    return {
      form: {
        senha_atual: '',
        nova_senha: '',
        confirmar_senha: ''
      },
      campoVazio: [],
      loading: false,
    }
  },
  computed: {
    erroSenhasDiferentes() {
      return this.form.nova_senha && this.form.confirmar_senha && this.form.nova_senha !== this.form.confirmar_senha;
    }
  },
  methods: {
    async mudarSenha() {
      this.campoVazio = [];
      if (!this.form.senha_atual) this.campoVazio.push('senha_atual');
      if (!this.form.nova_senha) this.campoVazio.push('nova_senha');
      if (!this.form.confirmar_senha) this.campoVazio.push('confirmar_senha');

      if (this.campoVazio.length > 0) {
        this.$toastMessage("warn", "Atenção", "Preencha todos os campos obrigatórios.");
        return;
      }

      if (this.erroSenhasDiferentes) {
        this.$toastMessage("warn", "Atenção", "A nova senha e a confirmação devem ser iguais.");
        return;
      }

      if (this.form.nova_senha.length < 6) {
        this.$toastMessage("warn", "Atenção", "A nova senha deve ter no mínimo 6 caracteres.");
        return;
      }

      this.loading = true;
      try {
        const response = await fetch(`${apiUrl.usuarios.usuarioLogado.replace('user/', 'primeiro-acesso/trocar-senha/')}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(this.form),
          credentials: 'include'
        });

        const data = await response.json();

        if (response.ok) {
          this.$toastMessage("success", "Sucesso", "Senha alterada com sucesso! Você será redirecionado.");
          
          // Limpar flag de primeiro acesso
          localStorage.removeItem('admin_primeiroAcesso');
          
          setTimeout(() => {
            this.$router.push('/');
          }, 1500);
        } else {
          this.$toastMessage("error", "Erro", data.detail || "Erro ao alterar a senha.");
        }
      } catch (error) {
        this.$toastMessage("error", "Erro", "Não foi possível conectar ao servidor.");
      } finally {
        this.loading = false;
      }
    },
    
    async logout() {
        localStorage.clear();
        this.$router.push('/login');
    }
  }
}
</script>


<style scoped>

.middle-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  width: 500px;
  padding: 2rem 0;
}

:deep(.p-password) {
  width: 100%;
}

:deep(.p-password-input) {
  width: 100%;
  box-sizing: border-box;
}

:deep(.p-password-mask),
:deep(.p-password-toggle-mask),
:deep(.p-password-toggle-mask-icon) {
  z-index: 99 !important;
  color: #333 !important;
}
</style>